import { IBagValueItem } from '@/modules/bags/ts';

export const getClassInfo = (values: IBagValueItem[] | undefined) => {
  const classItem = values?.find((item) => item.name === 'Класс');
  return classItem?.value ? `, ${classItem.value}-й класс` : '';
};
